/**
 * Converts a string into an enriched string with HTML tags
 * @param {String} text
 * @return {String} Formatted text including HTML tags
 *
 */
function formatRichText(text) {
    // Convert special syntax to HTML tags
    // For now we are simply using regular expressions, but in the future
    // we might want to have a defined grammer and use a custom parser.
    //
    // We assume that the text has been sanitized in the backend. As such,
    // we only perform really basic HTML escaping in the frontend.
    //

    const links = {};

    function randomId() {
        // we can use uuid here
        return Math.random()
            .toString()
            .replace("0.", "");
    }

    function cutOutLinks(text) {
        // save link for later with uniq ID
        //
        // If the link ends with a closing parenthesis, remove it from the link.
        // Even though parenthesis are valid URL characters, more often than not that is not the user's intention.
        //
        var link = /(https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9]{1,256}\b([-a-zA-Z0-9@:%_+.~#?&//=]*))/g;

        return text.replace(link, function(match) {
            const marker = "{link#" + randomId() + "}";
            links[marker] = match;
            return marker;
        });
    }

    function putInLinks(text) {
        // put the link back by ID
        var marker = /{link#[0-9]+}/g;
        return text.replace(marker, function(match) {
            return (
                "<a href='" +
                links[match] +
                "' target='_blank' rel='noopener'>" +
                links[match].replace(/&/, "&amp;") +
                "</a>"
            );
        });
    }

    // replace lists
    function inTag(tag, text) {
        return "<" + tag + ">" + text + "</" + tag + ">";
    }

    function parseLi(text) {
        var regexp = /^- (.*)/gm;
        return text.replace(regexp, function(match, text) {
            return inTag("li", text);
        });
    }

    function parseUl(text) {
        // eslint-disable-next-line no-control-regex
        var regexp = new RegExp("\n?^(- .*\n?)+", "gm");
        return text.replace(regexp, function(match) {
            return inTag("ul", parseLi(match)).replace(/\n/g, "");
        });
    }

    function parseBold(text) {
        return text.replace(/(\W|_|^)\*(.+?)\*(\W|_|$)/g, "$1<b>$2</b>$3");
    }

    function parseItalic(text) {
        return text.replace(/(\W|_|^)_(.+?)_(\W|_|$)/g, "$1<i>$2</i>$3");
    }

    function parseStrike(text) {
        return text.replace(/(\W|_|^)~(.+?)~(\W|_|$)/g, "$1<del>$2</del>$3");
    }

    text = cutOutLinks(text || "")
        .replace(/:-?\)/g, "🙂")
        .replace(/:-?D/g, "😀")
        .replace(/:-?P/g, "😛")
        .replace(/;-?\)/g, "😉")
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#x27;")
        .replace(/\//g, "&#x2F;");

    text = parseUl(text);

    for (var i = 0; i < 3; i++) {
        // three passes to account for ~*_nested_*~ formatting
        text = parseBold(text);
        text = parseItalic(text);
        text = parseStrike(text);
    }

    return putInLinks(text.replace(/\n/g, "<br>"));
}

export default formatRichText;
